import { AuctionType } from '../../../../../../auctions/types.ts';
import { AuctionColorPicker } from '../../../../../utils/AuctionGradientPicker.tsx';
import { ApplicationRoutes } from '../../../../../../../constants/appRoutes.ts';
import { SaleModel } from '../../../../../types.ts';
import { generateUrl } from '../../../../../../../constants/generateUrl.tsx';

export const useUpcomingAuctionCardContent = (model: SaleModel) => {
  return {
    name: model.Name,
    description: model.Description,
    saleTypeText: model.SaleTypeDisplayOverride || AuctionType[model.SaleType],
    color: AuctionColorPicker(model.SaleType),
    saleDate: model.SaleDateTime,
    saleTimeZone: model.SaleTimeZone,
    imageSrc: model.ImageSrc,
    customerUrl: model.CustomerUrl,
    customerText: model.CustomerText,
    saleCatalogueUrl: model.SaleCatalogueUrl,
    saleCatalogueText: model.SaleCatalogueText,
    saleUrl:
      model.SaleType === AuctionType.Timed
        ? model.ExternalSaleUrl
        : generateUrl(ApplicationRoutes.report.auctionLots, { auctionId: String(model.Id) }),
    infoDocumentText: model.InfoDocumentText,
    infoDocumentUrl: model.InfoDocumentUrl,
    videoText: model.VideoText,
    videoUrl: model.VideoUrl,
    websiteLinkText: model.WebsiteLinkText,
    websiteLinkUrl: model.WebsiteLinkUrl
  };
};
